import { ReportList } from '../dtos/Enums/ReportList';

export const INTERNAL_REPORT_MAP: Partial<Record<ReportList, boolean>> = {
      [ReportList.EstimateSummaryReportViewModel]:              true,
      [ReportList.ZeroCostMaterialByPartNumberViewModel]:       true,
      [ReportList.CostByPartNumberByTypeExpandedViewModel]:     true,
      [ReportList.CostByPartNumberExpandedViewModel]:           true,
      [ReportList.CostByLevelViewModel]:                        true,
      [ReportList.EstimateMaterialBreakdownViewModel]:          true,
      [ReportList.MaterialWithNotesByAreaViewModel]:            true,
      [ReportList.PartsByCountryViewModel]:                     true,
      [ReportList.SubcontrctorAndMiscCostViewModel]:            true,
      [ReportList.SubContractorMiscNotesViewModel]:             true,
      [ReportList.LaborByLevelReportViewModel]:                 true,
      [ReportList.MaterialTakeOffAndExtensionReportViewModel]:  true,
      [ReportList.LaborHoursBySalesOfficeReportViewModel]:      true,
      [ReportList.LaborHoursDistViewModel]:                     true,
      [ReportList.TaskByLevelWithNotesViewModel]:               true,
      [ReportList.TaskByLevelReportViewModel]:                  true,
      [ReportList.SystemsReportViewModel]:                      true,
      [ReportList.SystemNotesViewModel]:                        true,
      [ReportList.MaterialViewModel]:                           false,
      [ReportList.ControllerMaterialViewModel]:                 true,
      [ReportList.CostReviewCheckListReportViewModel]:          true,
      [ReportList.MaterialByPartTypeViewModel]:                 true,
      [ReportList.MaterialByTypeViewModel]:                     true,
      [ReportList.ServiceContractMaterialViewModel]:            true,
      [ReportList.SpecialPricingViewModel]:                     true,
      [ReportList.SubmittalReportViewModel]:                    true,
      [ReportList.WiringUsedViewModel]:                         false,
      [ReportList.TaskBasedLaborByAreaViewModel]:               true,
      [ReportList.TaskBasedLaborSummaryViewModel]:              true,
      [ReportList.UsedSymbolViewModel]:                         false,
      [ReportList.ApplicationDetailViewModel]:                  false,
      [ReportList.ElectricalServicesMaterialAndHoursViewModel]: true,
      [ReportList.FireEstimatingAnalyticsReportViewModel]:      true,
}